import { SettingOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { FactoryTable } from 'components/ui';
import { useFormReviewPivotTableStore } from 'stores/local';
import { noop } from 'utils/noop';

import { useFormReviewPage } from '../../context';

import { ColumnsSettingsDrawer } from './ColumnsSettingsDrawer';
import s from './Content.module.scss';

const Content: React.FC = () => {
  const { t } = useTranslation();
  const store = useFormReviewPivotTableStore();

  const { setStore, setFormName, setExtraHeaderButtons } = useFormReviewPage();

  React.useEffect(() => {
    store.init();
  }, [store]);

  React.useEffect(() => {
    setStore(store.formActionsStore);
  }, [setStore, store]);

  React.useEffect(() => {
    const name = store.tableStore.header?.name;
    if (name) {
      setFormName(name);
    }
  }, [setFormName, store.tableStore.header?.name]);

  React.useEffect(() => {
    setExtraHeaderButtons(
      <Button
        onClick={store.columnsSettingsDrawer.drawerState.open}
        icon={<SettingOutlined />}
      >
        {t('formReview.columnsSetup')}
      </Button>
    );

    return () => {
      setExtraHeaderButtons(null);
    };
  }, [setExtraHeaderButtons, store.columnsSettingsDrawer.drawerState.open, t]);

  return (
    <>
      <FactoryTable
        rowClassName={s.content__row}
        expandIcon={noop}
        pagination={false}
        rowKey="uniqueId"
        tableStore={store.tableStore}
      />
      <ColumnsSettingsDrawer />
    </>
  );
};

export default observer(Content);
